module.exports = __webpack_public_path__ + "static/media/Bloomberg-grey.35d53fe7.svg";